var map = {
	"./arrow.png": 2123,
	"./background.png": 3495,
	"./eInfo.png": 786,
	"./honor/honor1.png": 1877,
	"./honor/honor2.png": 4526,
	"./honor/honor3.png": 2839,
	"./huawei/huawei1.png": 4629,
	"./huawei/huawei2.png": 2526,
	"./huawei/huawei3.png": 215,
	"./ios/ios1.png": 4501,
	"./ios/ios2.png": 5726,
	"./ios/ios3.png": 5719,
	"./ios/ios4.png": 6104,
	"./logo.png": 2806,
	"./oppo/oppo1.png": 5683,
	"./oppo/oppo2.png": 9928,
	"./oppo/oppo3.png": 1057,
	"./title.png": 5201,
	"./vivo/vivo1.png": 4571,
	"./vivo/vivo2.png": 6240,
	"./vivo/vivo3.png": 7417,
	"./xiaomi/xiaomi1.png": 9901,
	"./xiaomi/xiaomi2.png": 9222,
	"./xiaomi/xiaomi3.png": 7311,
	"./xiaomi/xiaomi4.png": 8656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;